import React, { useState } from 'react';
import useAdminAuthStore from '../../stores/adminAuthStore';
import { useNavigate } from 'react-router-dom';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';

function AdminLogin() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const { login: loginAction, loading, error } = useAdminAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ok = await loginAction({ login, password });
    if (ok) navigate('/admin/groups');
  };

  return (
    <div className='Auth' style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form onSubmit={handleSubmit} style={{ width: 400, background: '#fff', borderRadius: 10, boxShadow: '0 0 7px 0 rgba(34,60,80,0.2)', padding: 32 }}>
        <div className='title' style={{ textAlign: 'center', fontSize: 18, fontWeight: 500, marginBottom: 20 }}>Вход для администратора</div>
        <div className='inputBlock' style={{ marginBottom: 16 }}>
          <input placeholder='Логин' value={login} onChange={e => setLogin(e.target.value)} autoFocus style={{ width: '100%' }} />
        </div>
        <div className='inputBlock' style={{ marginBottom: 16 }}>
          <input placeholder='Пароль' type='password' value={password} onChange={e => setPassword(e.target.value)} style={{ width: '100%' }} />
        </div>
        {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
        <button type='submit' style={{ width: '100%', padding: '10px 20px', background: '#4c20bb', color: '#fff', border: 'none', borderRadius: 5, fontWeight: 500, fontSize: 16 }} disabled={loading}>
          {loading ? 'Вход...' : 'Войти'}
        </button>
      </form>
      <AdminBottomNavBar />
    </div>
  );
}

export default AdminLogin; 